<div class="load-spinner" [ngClass]="{'inner': inner}" *ngIf="show"> <div class="spinner"> </div> </div>